import * as React from 'react'
import './App.scss'
import Footer from './components/footer/Footer'
import Header from './components/header/Header'
import Main from './Main'
import { observer } from 'mobx-react'
import { useStore } from './hooks/useStore'


const AppClient = observer(() => {
	const { clientViewStore } = useStore()
	return (
		<div className="App">
			{clientViewStore.externalHostedOrderFlow ? <div className="App__Content">
				<Main />
			</div> :
				<>
					<Header />
					<div className="App__Content">
						<Main />
					</div>
					<Footer />
				</>
			}

		</div>
	)
})


export default AppClient
